import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from "../views/Home";
import Supplier from "../views/supplier/Supplier";
import Review from "../views/review/Review";
import Score from "../views/score/Score";
import UserRanking from "@/views/user_ranking/UserRanking";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    props:(route) => ({
      op:route.query.op
    }),
    meta:{
      title: 'Home'
    },
  },

  {
    name: 'supplier',
    path: '/supplier/:sup_cd',
    component: Supplier,
    props:(route) => ({
      op:route.query.op,
      sup_cd:route.params.sup_cd,
    }),
    meta:{
      title: '仕入先'
    },
  },

  {
    name: 'review',
    path: '/supplier/:sup_cd/review',
    component: Review,
    props:(route) => ({
      op:route.query.op,
      sup_cd:route.params.sup_cd,
    }),
    meta:{
    },
  },

  {
    name: 'score',
    path: '/supplier/:sup_cd/score',
    component: Score,
    props:(route) => ({
      op:route.query.op,
      sup_cd:route.params.sup_cd,
    }),
    meta:{
    },
  },


  {
    name: 'supplier_search',
    path: '/search',
    component: () => import(/* webpackChunkName: "supplier_search" */ '../views/search/SupplierSearch'),
    props:(route) => ({
      op:route.query.op,
      search_query:route.query.q,
      page:route.query.p,
    }),
    meta:{
    },
  },

  {
    name: 'supplier_edit',
    path: '/supplier/:sup_cd/edit',
    component: () => import(/* webpackChunkName: "supplier_edit" */ '../views/supplier_edit/SupplierEdit'),
    props:(route) => ({
      op:route.query.op,
      sup_cd:route.params.sup_cd,
    }),
    meta:{
    },
  },


  {
    name: 'user_ranking',
    path: '/ranking',
    component: UserRanking,
    props:(route) => ({
      op:route.query.op,
    }),
    meta:{
    },
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
